import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject } from "rxjs";

import { Utils } from "src/app/commons/utils";
import { CHANNEL_CONFIG, NAV_MENU } from "src/app/config";
import { IChannel, IMenu, ISiteConfig } from "../ITypes";
import { SettingsService } from "src/app/layout/settings/services/settings.service";
import { IMenuAccess } from "src/app/layout/settings/types";

@Injectable({
  providedIn: "root",
})
export class SiteConfigService {
  private selectedConfig: ISiteConfig;
  private menuItems = new BehaviorSubject<IMenu[]>([]);

  menuItems$ = this.menuItems.asObservable();

  constructor(
    @Inject(NAV_MENU) private menu: IMenu[],
    @Inject(CHANNEL_CONFIG) private channels: IChannel[],
    private _http: HttpClient,
    private settingsService: SettingsService
  ) {}

  async refreshMenuItems(menuAccess: IMenuAccess[]) {
    try {
      let menuConfig = Utils.cloneObj(this.menu) || [];
      if (menuAccess && Array.isArray(menuAccess) && menuAccess.length > 0) {
        const allowedSlugs = menuAccess.map((m) => m.slug);
        menuConfig = menuConfig
          .filter((item) => allowedSlugs.includes(item.slug))
          .map((item) => {
            item.visible = true;
            return item;
          });
      }

      this.menuItems.next(menuConfig);
    } catch (err) {
      this.menuItems.next(this.defaultMenuItems);
    }
  }

  async load(merchantId) {
    const selectedTenant = this.channels.find(
      (channel) => channel.id === +merchantId
    );
    const configPath = selectedTenant.configPath || "panda";

    return new Promise(async (resolve, reject) => {
      await import(`src/app/tenants/${configPath}/config.js`)
        .then(async (res) => {
          const result = Utils.cloneObj(res);
          this.setConfig(result.config);

          if (!this.settingsService.settingsDetails) {
            await this.loadTenantSettings();
          }

          resolve(this.selectedConfig);
        })
        .catch((e) => {
          reject("Sorry, config is not found");
        });
    });
  }

  async loadTenantSettings() {
    try {
      const settings = await this.settingsService.fetch();
      let menuConfig = this.menu || [];

      if (
        settings &&
        Array.isArray(settings.menuAccess) &&
        settings.menuAccess.length > 0
      ) {
        const allowedSlugs = settings.menuAccess.map((m) => m.slug);
        // Only include menu items whose slug is present in settings.menuAccess
        menuConfig = menuConfig
          .filter((item) => allowedSlugs.includes(item.slug))
          .map((item) => {
            item.visible = true;

            return item;
          });
      } else {
        menuConfig = this.defaultMenuItems;
      }

      this.menuItems.next(menuConfig);
    } catch (err) {
      this.menuItems.next(this.defaultMenuItems);
    }
  }

  get defaultMenuItems() {
    if (this.settingsService.settingsDetails) {
      const defaultMenus =
        this.settingsService.settingsDetails.defaultMenus || [];
      if (Array.isArray(defaultMenus) && defaultMenus.length > 0) {
        return (
          this.menu.filter((item) => defaultMenus.includes(item.slug)) || []
        );
      }
    }

    return this.menu.filter((item) => item.showDefault) || [];
  }

  get options() {
    return this.selectedConfig;
  }

  setItem(key, val) {
    Utils.updateObjProp(this.selectedConfig, key, val);
  }

  getItem(key) {
    return Utils.getPropByString(this.selectedConfig || {}, key);
  }

  private setConfig(config) {
    this.selectedConfig = config;
    this.setMenuItems();
  }

  private setMenuItems() {
    let menuConfig = this.menu || [];
    const allowedSlugs = this.settingsService.menuAccess.map((m) => m.slug);

    menuConfig = menuConfig
      .filter((item) => allowedSlugs.includes(item.slug))
      .map((item) => {
        item.visible = true;

        return item;
      });

    /* const menuItems = Utils.cloneObj(this.menu).map(
      (item) => {
        const sideNav = this.selectedConfig.side_nav;

        if (sideNav && sideNav.enable_menus) {
          const isEnabled = sideNav.enable_menus.indexOf(item.slug) != -1;

          if (isEnabled) {
            item.visible = true;
          }
        }

        if (sideNav && sideNav.disableMenus) {
          const isDisabled = sideNav.disableMenus.indexOf(item.slug) != -1;

          if (isDisabled) {
            item.visible = false;
          }
        }

        return item;
      }
    ); */

    this.menuItems.next(menuConfig);
  }
}
